import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { useUnmatchedProducts } from '@/hooks/useInventorySyncReport';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertTriangle } from 'lucide-react';

export function UnmatchedProductsTable() {
  const { data, isLoading } = useUnmatchedProducts();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-amber-500" />
          Unmatched Products
        </CardTitle>
        <CardDescription>
          Product names from sync data that don't match any internal product or variation. These need to be added to the product list or mapped as variations.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? <Skeleton className="h-48" /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Source</TableHead>
                  <TableHead>Product Name</TableHead>
                  <TableHead>Last Seen</TableHead>
                  <TableHead className="text-right">Occurrences</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {(data || []).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} className="text-center text-muted-foreground py-8">
                      All products matched! No unmatched products found.
                    </TableCell>
                  </TableRow>
                ) : (
                  (data || []).map((item) => (
                    <TableRow key={`${item.source}-${item.productName}`}>
                      <TableCell>
                        <Badge variant={item.source === 'B2B' ? 'default' : 'secondary'}>
                          {item.source}
                        </Badge>
                      </TableCell>
                      <TableCell className="font-medium">{item.productName}</TableCell>
                      <TableCell>{item.lastSeen}</TableCell>
                      <TableCell className="text-right font-mono">{item.occurrences}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
